import { render } from "./SingleBody.vue?vue&type=template&id=fad80186"
import script from "./SingleBody.vue?vue&type=script&lang=js"
export * from "./SingleBody.vue?vue&type=script&lang=js"

import exportComponent from "/home/mw/Code/hc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__